import * as Url from "../fetch/basicThunk";

export const HOST_URL = Url.url;

export const QUERY_POST_WORKSHOPLIST = "workshops"
export const QUERY_GET_CASES = "cases";
export const QUEY_GET_MASTER_COUNT = "masters/countPages";
export const QUERY_PUT_UPDATECASELIST = "cases/updateList";
export const QUERY_PUT_SETNOTMANAGED = "cases/SetNotManaged";
export const QUERY_GET_CONTRACT = "contracts";
export const QUERY_GET_CONTRACT_BY_CASE_ID = "contracts/GetByCaseId/";
export const QUERY_GET_VEHICLES = "vehicles";
export const QUERY_GET_ITVS = "itvs";
export const QUERY_GET_PROVINCES = "itvs/provinces";
export const QUERY_GET_CUSTOMERS = "customers";
export const QUERY_GET_ALL_CUSTOMERS_ALL = "customers/all";
export const QUERY_POST_LOGIN = "accounts/login"
export const QUERY_POST_TAXONOMY = "masters/taxonomies"
export const QUERY_GET_TAXONOMIES = "masters/alltaxonomies"
export const QUERY_POST_EXPORT_EXCEL ="masters/exportexcel"
export const QUERY_GET_DOWNLOAD_FILE ="masters/DownloadFile"
export const QUERY_GET_TAXONOMIESTREE = "masters/taxonomiestree"
export const QUERY_GET_TEMPLATES = "masters/templates"
export const QUERY_GET_DOCUMENTATION_TEMPLATES = "masters/documentationtemplates"
export const QUERY_GET_LETTER_TYPES = "masters/letterTypes"
export const QUERY_GET_CASESTATES ="caseStates/casestates"
export const QUERY_GET_CASESTATESPAG ="caseStates/casestatespag"
export const QUERY_GET_SUBSTATES ="caseStates/casesubstates"
export const QUERY_GET_SUBSTATESPAG ="caseStates/CaseSubStatesPag"
export const QUERY_POST_CREATECASESTATE = "caseStates/create"
export const QUERY_DELETE_DELETECASESTATE = "caseStates/delete/"
export const QUERY_PUT_EDITCASESTATE = "caseStates/update"
export const QUERY_GET_ACTIONRESOLUTIONS ="masters/actionresolutions"
export const QUERY_GET_ENTRYCHANNELS ="entryChannels/EntryChannels"
export const QUERY_GET_ENTRYCHANNELSPAG = "entryChannels/EntryChannelsPag"
export const QUERY_POST_CREATEENTRYCHANNEL = "entryChannels/create"
export const QUERY_DELETE_DELETEENTRYCHANNEL = "entryChannels/delete"
export const QUERY_PUT_EDITENTRYCHANNEL = "entryChannels/update"
export const QUERY_PUT_UPDATECASE= "cases/update"
export const QUERY_POST_CREATECASE= "cases/create"
export const QUERY_PUT_BLOCKCASE= "cases/block"
export const QUERY_GET_ISCASEBLOCKEDBYUSER= "cases/checkblock"
export const QUERY_PUT_ISCASEWITHOUTPLATE= "cases/markCaseWithoutPlate"
export const QUERY_GET_BY_CALL_ID= "cases/GetCaseByCallId"
export const QUERY_GET_NEWCASE = "cases/new"
export const QUERY_GET_COMMENTS_CASE_BY_ID = "cases/GetCommentsByCaseId/"
export const QUERY_PUT_UPDATE_CONTRACT_DATA = "contracts/updateContractData"
export const QUERY_GET_CUSTOMER_CONTRACT_DATA = "contracts/GetCustomerContractData"
export const QUERY_POST_CALL = "calls/CreateIfNotExists"
export const QUERY_POST_ASSOCIATE_CALL = "calls/AssociateCall"
export const QUERY_POST_GENERATE_DOC = "documentation/GenerateDocumentation"
export const QUERY_PUT_ASSOCIATE_CONTRACT = "cases/AssociateContract"
export const QUERY_POST_SMS = "sms/SendInternal"
export const QUERY_GET_CONTRACT_SIMPLE = "contracts/GetContractSimple"
export const QUERY_GET_WORKSHOP_SEARCH = "workshops/SearchWeb"
export const QUERY_GET_CONTRACT_HISTORY = "contracts/getContractHistory"
export const QUERY_GET_WORKSHOP_TYPES = "masters/workshopTypes"
export const QUERY_PUT_UPDATE_CLICKTOCALL = "cases/updateClickToCall"
export const QUERY_PUT_SETCASEATTENDANCE = "cases/SetCaseAttendance"
export const QUERY_GET_PROVINCE_BY_POSTALCODE = "itvs/provinces"
export const QUERY_POST_SET_WORKSHOP_APPOINTMENT = "casesTemplates/setWorkshopAppointment"
export const QUERY_GET_WORKSHOP_APPOINTMENT_TEMPLATES = "masters/workshopAppointmentTemplates"
export const QUERY_GET_DOCUMENTATION_REQUEST_TEMPLATES = "masters/documentationRequestTemplates"
export const QUERY_GET_ITVS_BY_POSTAL_CODE = "itvs"
export const QUERY_POST_SET_DOCUMENTATION = "casesTemplates/setDocumentation"
export const QUERY_POST_SET_TERMINATIONS = "casesTemplates/setTerminations"
export const QUERY_POST_SET_SUBSTITUTION = "casesTemplates/setSubstitution"
export const QUERY_POST_SET_OTHER_FACTORY_PROCESS =  "casesTemplates/setOther"
export const QUERY_POST_EMAIL = 'email/send'
export const QUERY_GET_EMAIL_FROM_TEMPLATE = 'email/emailRecipientFromTemplate'
export const QUERY_POST_EMAIL_EXTERNAL = 'email/sendExternal'
export const QUERY_GET_EMAIL_BYMESSAGEID = 'email/GetByMessageId'
export const QUERY_POST_SET_CLAIMS = "casesTemplates/setClaims"
export const QUERY_POST_SET_DELIVERY = "casesTemplates/setDelivery"
export const QUERY_POST_SET_OVC = "casesTemplates/setOvc"
export const QUERY_POST_SET_ITV = "casesTemplates/setItv"
export const QUERY_POST_SET_FUELCARD = "casesTemplates/setFuelCard"
export const QUERY_POST_SET_MARSH = "casesTemplates/setMarsh"
export const QUERY_POST_SET_LETTER = "casesTemplates/setLetters";
export const QUERY_POST_SET_LETTER_QUERY = "casesTemplates/setLetterQuery";
export const QUERY_GET_TAXONOMY_TEMPLATES = "masters/getTaxonomyTemplates";
export const QUERY_GET_FACTORY_CASES_BY_PLATE = 'factoryCases/GetFactoryCasesByPlate'
export const QUERY_POST_FACTORY_COMMENT = 'factoryCases/postComment'
export const QUERY_POST_ADVANCE_FACTORY_CASE = 'factoryCases/advanceCase'
export const QUERY_GET_FACTORY_PROVINCES = "factoryMasters/provinces";
export const QUERY_GET_FACTORY_PROVINCES_WITH_OFFICES = 'factoryMasters/provincesWithOffices'
export const QUERY_GET_FACTORY_CITIES = 'factoryMasters/citiesByProvinceId'
export const QUERY_GET_FACTORY_OFFICES_BY_PROVINCE = 'factoryMasters/officesByProvinceId'
export const QUERY_GET_FACTORY_OFFICES_BY_CITY = 'factoryMasters/officesByCityId'
export const QUERY_GET_FACTORY_RENT_TYPES = 'factoryMasters/rentTypes'
export const QUERY_GET_FACTORY_CHANNELS = 'factoryMasters/channels'
export const QUERY_GET_FACTORY_CATEGORIES = 'factoryMasters/categories'
export const QUERY_GET_FACTORY_RATES = 'factoryMasters/rates'
export const QUERY_GET_FACTORY_TYPES = 'factoryMasters/types'
export const QUERY_GET_FACTORY_BRANCHES = 'factoryMasters/branchesByPlate';
export const QUERY_GET_FACTORY_ITV_BOND_INFO = "factoryMasters/ITVBondInfo";
export const QUERY_POST_REGRESS_FACTORY_CASE = 'factoryCases/regressCase'
export const QUERY_GET_FACTORY_CATEGORIES_VH_UNLIMITED = 'factoryMasters/SubsitutionVehicleCategory'
export const QUERY_GET_FACTORY_MODALITY_BAG = 'factoryMasters/modalityBag'
export const QUERY_GET_FACTORY_MODALITY_POOL = 'factoryMasters/modalityPool'
export const QUERY_GET_FACTORY_MODALITY_TYPE_DAYS_YEAR = 'factoryMasters/modalityTypeDaysYear'
export const QUERY_GET_FACTORY_TERMINATION_PROVINCES = 'factoryMasters/terminationProvinces'
export const QUERY_GET_FACTORY_TERMINATION_CITIES = 'factoryMasters/terminationCitiesByProvinceCode'
export const QUERY_GET_FACTORY_SALESFORCE = 'factoryMasters/AccountCodeSF'
export const QUERY_PUT_ATTACH_IDT_PROCESS_TO_CASE = 'cases/AttachIdtProcessToCase'
export const QUERY_GET_INTERACTION_CODE = "cases/GetInteractionCode"
export const QUERY_POST_NEW_IDT_PROCESS_FROM_INTERACTION_CODE = "idt/NewProcessByInteractionCode"
export const QUERY_GET_IDT_PROCESS_BY_ID = "Idt/GetIdtProcessById"
export const QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID = "Idt/GetIdtPlaceholderValuesByProcessId"
export const QUERY_GET_IDT_PROCESS_TYPES = "Idt/GetIdtProcessTypes"
export const QUERY_UPDATE_IDT_PROCESS = 'Idt/UpdateIdtProcess'
export const QUERY_CLOSE_IDT_PROCESS = 'Idt/CloseIdtProcess'
export const QUERY_UPDATE_IDT_PLACEHOLDER_VALUE = 'Idt/UpdateIdtPlaceholderValue'
export const QUERY_UPDATE_IDT_PLACEHOLDER_VALUE_LIST = 'Idt/UpdateIdtPlaceholderValueList'
export const QUERY_OPEN_LINKED_PROCESS = 'Idt/OpenIdtLinkedProcess'
export const QUERY_RETURN_PARENT_PROCESS = 'Idt/ReturnToParentProcess'
export const QUERY_SEND_IDT_API_REQUEST = 'Idt/SendApiRequest'
export const QUERY_GET_CHECK_WORKER_SERVICE_STATUS = 'factoryCases/checkWorkerServiceStatus'
export const QUERY_GET_IDT_ENTITY_PARAMETERS = 'Idt/GetIdtEntityParameters'
export const QUERY_GET_INTERACTIONS ="interactions/Interactions"
export const QUERY_GET_INTERACTIONSPAG = "interactions/InteractionsPag"
export const QUERY_POST_CREATEINTERACTION = "interactions/create"
export const QUERY_DELETE_DELETEINTERACTION = "interactions/delete/"
export const QUERY_PUT_EDITINTERACTION = "interactions/update"
export const QUERY_GET_USERS = "users/Users"
export const QUERY_GET_TAXONOMIES_ADMIN = "taxonomies"
export const QUERY_GET_TAXONOMIES_ADMIN_PAGINATED = "taxonomies/paginated"
export const QUERY_POST_TAXONOMIES_ADMIN_CREATE = "taxonomies/create"
export const QUERY_PUT_TAXONOMIES_ADMIN_UPDATE = "taxonomies/update"
export const QUERY_DELETE_TAXONOMIES_ADMIN = "taxonomies/delete"
export const QUERY_GET_TAXONOMY_DESCRIPTIONS = "masters/taxonomyDescriptions"
export const QUERY_GET_ROLES = "roles"
export const QUERY_GET_USERS_WITH_ROLES_PAGINATED = "users/UsersWithRolesPaginated"
export const QUERY_POST_CREATE_USER = "users/create"
export const QUERY_PUT_UPDATE_USER = "users/update"
export const QUERY_DELETE_USER = "users/delete"
export const QUERY_POST_CREATE_SUBSTATE ="caseStates/CreateSubState"
export const QUERY_PUT_UPDATE_SUBSTATE = 'caseStates/UpdateSubState'
export const QUERY_DELETE_DELETE_SUBSTATE = 'caseStates/DeleteSubState/'
export const QUERY_GET_EXCEPTIONS = 'exceptions/ExceptionsPag'
export const QUERY_GET_EXCEPTION_LEVELS = 'exceptions/exceptionLevels'
export const QUERY_POST_CREATE_EXCEPTION = 'exceptions/Create'
export const QUERY_PUT_UPDATE_EXCEPTION = 'exceptions/Update'
export const QUERY_DELETE_DELETE_EXCEPTION = 'exceptions/Delete/'
export const QUERY_GET_CONTRACT_LIST = "Contracts/GetContractList"
export const QUERY_PUT_UPDATE_CONTRACT = 'Contracts/UpdateContract'
export const QUERY_GET_TEMPLATES_PAG = "templates/templatesPag"
export const QUERY_GET_TEMPLATE_TYPES = "templates/templateTypes"
export const QUERY_GET_EMAIL_RECIPIENTS = "templates/emailRecipients"
export const QUERY_POST_CREATE_TEMPLATE = "templates/create"
export const QUERY_PUT_UPDATE_TEMPLATE = "templates/update"
export const QUERY_DELETE_TEMPLATE = 'templates/delete'
export const QUERY_GET_EXTERNAL_USERS = 'users/externalUsers'
export const QUERY_POST_CREATE_EXTERNAL_USER = 'users/createExternal'
export const QUERY_PUT_UPDATE_EXTERNAL_USER = 'users/updateExternal'
export const QUERY_PUT_UPDATE_PREFERRED_LANGUAGE = 'users/preferredlanguage'
export const QUERY_PUT_UPDATE_PASSWORD = 'users/updatePassword'
export const QUERY_DELETE_EXTERNAL_USER = 'users/deleteExternal'
export const QUERY_GET_WORKSHOPS_ADMIN = 'workshops/admin';
export const QUERY_POST_CREATE_WORKSHOP = 'workshops/create';
export const QUERY_PUT_UPDATE_WORKSHOP = 'workshops/update';
export const QUERY_DELETE_WORKSHOP = 'workshops/delete'
export const QUERY_GET_BRANDS = 'masters/brands';
export const QUERY_GET_NETWORKS = 'masters/networks';
export const QUERY_GET_WORKSHOP_SERVICES = 'masters/workshopServices';
export const QUERY_GET_CATEGORIES = 'masters/categories';
export const QUERY_IMPORT_FILE = 'fileManager/import';
export const QUERY_GET_IMPORT_FILE_TYPES = 'masters/fileImportTypes'
export const QUERY_GET_IMPORT_FILE_JOBS = 'fileManager/importJobs'
export const QUERY_GET_IMPORT_FILE_STATES = 'masters/fileImportStates'
export const QUERY_GET_CAMPAIGNS = 'campaigns'
export const QUERY_GET_CAMPAIGN_TYPES = 'masters/campaignTypes'
export const QUERY_POST_CREATE_CAMPAIGN = 'campaigns/create'
export const QUERY_PUT_UPDATE_CAMPAIGN = 'campaigns/update'
export const QUERY_DELETE_CAMPAIGN = 'campaigns/delete'
export const QUERY_GET_USER_DATA = "users/userData"

export const QUERY_GET_CASE_KPI = 'kpis/cases'
export const QUERY_GET_AGENT_KPI = 'kpis/agents'

export const QUERY_GET_MAIL_MAPPERS = 'mailMapper/MailMapperPag'
export const QUERY_POST_CREATE_MAIL_MAPPER = 'mailMapper/create'
export const QUERY_PUT_UPDATE_MAIL_MAPPER = 'mailMapper/update'
export const QUERY_DELETE_MAIL_MAPPER = 'mailMapper/delete'

export const QUERY_GET_CAMPAIGN_STATISTICS = 'campaigns/campaignStatistics'
export const QUERY_GET_CAMPAIGNS_MASTER = 'masters/campaigns'

export const QUERY_GET_SERVICES = 'services';
export const QUERY_GET_SERVICES_ADMIN = 'services/admin';
export const QUERY_POST_CREATE_SERVICE = "services/create"
export const QUERY_PUT_UPDATE_SERVICE = "services/update"
export const QUERY_DELETE_SERVICE = "services/delete"
export const QUERY_GET_SERVICES_USER = 'services/user';

export const QUERY_GET_FACTORY_ADVANCE_OPTIONS = "factoryCases/advanceOptions"

export const QUERY_POST_CHAT_ASSIST_SENDMESSAGE = "chatAssist/SendMessage"
export const QUERY_GET_CHAT_ASSIST_MESSAGE_HISTORY = "chatAssist/GetChatMessages"

export const QUERY_GET_SUPPLIERS = "suppliers/Suppliers";
export const QUERY_GET_SUPPLIERSPAG = "suppliers/SuppliersPag";
export const QUERY_POST_CREATE_SUPPLIER = "suppliers/create";
export const QUERY_PUT_EDIT_SUPPLIER = "suppliers/update";
export const QUERY_DELETE_SUPPLIER = "suppliers/delete";
export const QUERY_PUT_TOGGLE_ACTIVE_SUPPLIER = "Suppliers/ToggleActive";

export const QUERY_GET_SUPPLIER_SERVICE_TYPES = "SupplierServiceTypes/SupplierServiceTypes";
export const QUERY_GET_SUPPLIER_SERVICE_TYPESPAG = "SupplierServiceTypes/SupplierServiceTypesPag";
export const QUERY_POST_CREATE_SUPPLIER_SERVICE_TYPE = "SupplierServiceTypes/Create";
export const QUERY_PUT_EDIT_SUPPLIER_SERVICE_TYPE = "SupplierServiceTypes/Update";
export const QUERY_DELETE_SUPPLIER_SERVICE_TYPE = "SupplierServiceTypes/Delete";

export const QUERY_GET_SUPPLIER_PRICINGS_BY_SUPPLIER = "SupplierPricing/supplier";
export const QUERY_GET_SUPPLIER_PRICING_BY_ID = "SupplierPricing";
export const QUERY_POST_CREATE_SUPPLIER_PRICING = "SupplierPricing/Create";
export const QUERY_PUT_EDIT_SUPPLIER_PRICING = "SupplierPricing/Update";
export const QUERY_DELETE_SUPPLIER_PRICING = "SupplierPricing/Delete";

export const QUERY_GET_SUPPLIER_SERVICES_BY_SUPPLIER = "SupplierServices/supplier";
export const QUERY_POST_CREATE_SUPPLIER_SERVICE = "SupplierServices/Create";
export const QUERY_DELETE_SUPPLIER_SERVICE = "SupplierServices/Delete";

export const QUERY_GET_CUSTOMERS_PAG = "customers/CustomersPag";
export const QUERY_POST_CREATE_CUSTOMER = "customers/create";
export const QUERY_PUT_EDIT_CUSTOMER = "customers/update";
export const QUERY_DELETE_CUSTOMER = "customers/delete";
export const QUERY_PUT_TOGGLE_ACTIVE_CUSTOMER = "customers/ToggleActive";

export const QUERY_GET_CUSTOMER_SERVICES_BY_CUSTOMER = "CustomerServices/customer";
export const QUERY_POST_CREATE_CUSTOMER_SERVICE = "CustomerServices/Create";
export const QUERY_DELETE_CUSTOMER_SERVICE = "CustomerServices/Delete";

export const QUERY_GET_CUSTOMER_PRICINGS_BY_CUSTOMER = "CustomerPricing/customer";
export const QUERY_GET_CUSTOMER_PRICING_BY_ID = "CustomerPricing";
export const QUERY_POST_CREATE_CUSTOMER_PRICING = "CustomerPricing/Create";
export const QUERY_PUT_EDIT_CUSTOMER_PRICING = "CustomerPricing/Update";
export const QUERY_DELETE_CUSTOMER_PRICING = "CustomerPricing/Delete";

export const QUERY_GET_BILLING_TICKETS = "billing/tickets";
export const QUERY_GET_BILLING_SUPPLIER_TICKETS = "billing/supplier/tickets";
export const QUERY_GET_BILLING_DRAFTS = "billing/drafts";
export const QUERY_POST_BILLING_IMPORT = "billing/import";
export const QUERY_POST_BILLING_ASSOCIATE_DRAFT = "billing/drafts/";
export const QUERY_POST_BILLING_EXPORT = "billing/export";
export const QUERY_GET_BILLING_TICKETS_BY_CASE_ID = "billing/case";
export const QUERY_GET_BILLING_PAYMENT_ORDERS = "billing/case";
export const QUERY_GET_BILLING_CASE_HISTORY = "billing/case";
export const QUERY_POST_BILLING_CREATE_PAYMENT_ORDER = "billing/case";
export const QUERY_PUT_BILLING_UPDATE_PAYMENT_ORDER = "billing/payment-orders";
export const QUERY_PUT_BILLING_PAYMENT_ORDER_APPROVAL = "billing/payment-orders";
export const QUERY_PUT_BILLING_TICKET = "billing/tickets";
export const QUERY_POST_BILLING_LINK_PARENT = "billing/tickets";
export const QUERY_POST_BILLING_UNLINK_PARENT = "billing/tickets";
export const QUERY_GET_BILLING_SEARCH_PARENTS = "billing/tickets/search-parent-candidates";